import {Divider, Grid, Link, Stack} from '@mui/material';
import Typography from '@mui/material/Typography';
import {useState} from 'react';
import Configurator from '@/pages/Configurator/Configurator';
import CadPreviewImage from '@/pages/Preview/CadPreviewImage';
import ViewOrDownloadButtonGroup from '@/pages/Preview/ViewOrDownloadButtonGroup';
import type {Cad} from '@/types/stock-card';

const Home = (): JSX.Element => {
    const [previewLink, setPreviewLink] = useState<Cad | null>(null);

    return (
        <Grid container>
            <Grid size={{xs: 12, sm: 6}} offset={{sm: previewLink ? 0 : 3}}>
                <Typography variant="h6" gutterBottom>
                    Product Configurator
                </Typography>
                <Typography sx={{mb: 2}}>
                    This tool will allow you to request a quote and download 2D or 3D CAD files for
                    IPTS products. Begin by selecting the type of product from the product line
                    drop-down menu. Continue by selecting the Model, Size, Ratio, Assembly Position,
                    C-Face Size and other options from the respective drop-down menus until there
                    are no selections remaining.
                </Typography>
                <Typography sx={{mb: 2}}>
                    Not familiar with the IPTS product numbering or unsure which reducer you need?{' '}
                    <Link href="mailto:sales@iptsinc.com">Contact us</Link> and we will be happy to
                    assist you.
                </Typography>
                <Divider sx={{mb: 3}} />
                <Configurator previewLink={previewLink} setPreviewLink={setPreviewLink} />
            </Grid>
            {previewLink && (
                <Grid size={{xs: 12, sm: 6}} sx={{p: 2}}>
                    <Typography variant="h6" gutterBottom sx={{textAlign: 'center'}}>
                        Product Preview
                    </Typography>
                    {previewLink.png && (
                        <CadPreviewImage key={previewLink.png} src={previewLink.png} />
                    )}
                    <Stack
                        spacing={2}
                        direction="row"
                        sx={{justifyContent: 'center', alignItems: 'center'}}
                    >
                        {previewLink.dwg && (
                            <ViewOrDownloadButtonGroup
                                fileType="DWG"
                                fileLink={previewLink.dwg}
                                viewerLink={previewLink.dxf}
                            />
                        )}
                        {previewLink.step && (
                            <ViewOrDownloadButtonGroup
                                fileType="STEP"
                                fileLink={previewLink.step}
                            />
                        )}
                    </Stack>
                </Grid>
            )}
        </Grid>
    );
};

export default Home;
